import PropTypes from 'prop-types'
import React from 'react'
import classes from './Options.scss'
import Button from 'components/Button'
import List from 'components/List'

export const Options = (props) => {
  const data = props.options.map((option, index) => ({
    link: `/options/${option.id}/edit`,
    data: [
      option.name
    ]
  }))
  const headers = [
    'name'
  ]

  return (
    <div className={classes['collection']}>
      <header className={classes['header']}>
        <div className={classes['header-title']}>
          Browsing Specs
          <span className={classes['header-title--unimportant']}> – {props.options.length}</span>
        </div>

        <div className={classes['header-buttons']}>
          <Button options={['green', 'small']} element='a' href='/options/new'>
            Add Spec
          </Button>
        </div>
      </header>

      <List data={data} headers={headers} />
    </div>
  )
}

Options.propTypes = {
  options: PropTypes.array.isRequired
}

Options.defaultProps = {
  options: []
}

export default Options



// WEBPACK FOOTER //
// ./src/components/Options/Options.js